import { Injectable } from '@angular/core';
import { UserRoleService } from '../user-role.service';
import { UserRole } from '@shared/enums/user-role/user-role.enum';

@Injectable({
  providedIn: 'root'
})
export class RedeliveryRolesService {

  loggedUserRoles$ = this.userRolesService.loggedUserRoles$;

  constructor(
    private userRolesService: UserRoleService
  ) { }

  allowAccessToTheUi(): boolean {
    return this.userRolesService.checkIfAnyRoleMatch(
      [
        UserRole.ramAccessorialMgmtOps,
        UserRole.ramAccessorialMgmtOpsTest,
        UserRole.ramAccessorialMgmtCorr,
        UserRole.ramAccessorialMgmtCorrTest,
        UserRole.defaultTabigator,
      ],
    );
  }

  allowConfirm(): boolean {
    return this.userRolesService.checkIfAnyRoleMatch(
      [
        UserRole.ramAccessorialMgmtOps,
        UserRole.ramAccessorialMgmtOpsTest,
      ],
    );
  }
}
